/**
 * Example template component.  Don't edit this file directly!
 *
 * This template is specific to this project and not included in the core page templates.
 * We can create templates here for any we don't want included in the core template set.
 *
 * New templates can be bootstrapped from this manually,
 * or via the createtemplate cli script with the local option.
 */
import { useContentNodeContext } from '@edelman/providers';
import { getMetaDataFromSB } from '@edelman/seo';
import { useVariantImport } from '@edelman/storyblok-ui/src/hooks';
import { SBProps } from '@edelman/utils';

import * as Variant from './variants';

// Variants
const componentVariants = {
  default: Variant.DefaultVariant,
};

// Page classname identifier
const pageClassName = 'my-template';

export const SBProjectExampleTemplate = ({ blok }: SBProps) => {
  const { name: pageTitle } = useContentNodeContext();
  const { metaTitle, shortDescription, previewImage, layoutVariant = 'default' } = blok;

  // Add page specific meta
  const meta = getMetaDataFromSB({
    title: metaTitle || pageTitle,
    description: shortDescription,
    ogImage: previewImage,
  });

  // Load variant
  const VariantPage = useVariantImport({
    moduleUrl: import.meta.url,
    componentVariants,
    layoutVariant,
    importLocal: false,
    componentType: 'template',
  });

  return <VariantPage meta={meta} blok={blok} className={pageClassName} />;
};
